import { render, staticRenderFns } from "./RoleManage.vue?vue&type=template&id=b3be7a36&scoped=true&"
import script from "./RoleManage.vue?vue&type=script&lang=js&"
export * from "./RoleManage.vue?vue&type=script&lang=js&"
import style0 from "./RoleManage.vue?vue&type=style&index=0&id=b3be7a36&scoped=true&lang=css&"
import style1 from "./RoleManage.vue?vue&type=style&index=1&id=b3be7a36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3be7a36",
  null
  
)

export default component.exports